import SaudeSuplementarRoutes from './saudesuplementar/routes';

const ANS = () => import('./main.vue');

export default [
  {
    name: 'ans',
    path: '/ans',
    component: ANS,
    meta: {
      requiresAuth: true,
      breadcrum: 'ANS',
      icon: 'shield-alt',
      can: 'list',
      on: 'ans',
      filho: true,
    },
    children: [
      ...SaudeSuplementarRoutes,
    ],
  },
];
